import { site } from "../content/site";
import { PhoneMockup } from "./PhoneMockup";
import { Reveal } from "./Reveal";
import { SectionHeader } from "./SectionHeader";

export const AppShowcase = () => (
  <section className="border-t border-gray-200 bg-white" data-testid="app-showcase-section">
    <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8 lg:py-24">
      <SectionHeader
        eyebrow={site.showcase.eyebrow}
        heading={site.showcase.heading}
        subcopy={site.showcase.subcopy}
        testid="showcase-heading"
      />
      <div className="mt-14 grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-3">
        {site.showcase.screens.map((screen, i) => (
          <Reveal key={screen.id} delay={i * 0.1} className="flex flex-col items-center gap-4">
            <div className="rounded-[36px] border border-gray-200 bg-gray-50 p-5">
              <PhoneMockup screen={screen.id} />
            </div>
            <p className="text-sm font-semibold text-gray-700">{screen.caption}</p>
          </Reveal>
        ))}
      </div>
      <p className="mt-10 text-center text-xs text-gray-400" data-testid="showcase-placeholder-note">
        {site.showcase.placeholderNote}
      </p>
    </div>
  </section>
);
